module.exports = __webpack_public_path__ + "img/life-insurance-icon.f95338e9.svg";